/**
 * Inspirational quote field mapping.
 *
 * Backend contract (confirmed against civicrush-backend): `PUT /users/:id`
 * permits `:quote` in user_params (app/controllers/users_controller.rb) and
 * every user jbuilder partial serializes it back. The alternate names the
 * public profile once guessed at (`user_quote`, `favorite_quote`) exist
 * nowhere in the backend.
 *
 * There is no author field — the quote is stored as a single string.
 */

export const QUOTE_FIELD = 'quote'

/** Read a user's quote, coercing null to an empty string for the editor. */
export function readQuote(user) {
  return user?.[QUOTE_FIELD] ?? ''
}

/** Build the `user` payload for a quote save. */
export function buildQuotePayload(quote) {
  return { [QUOTE_FIELD]: quote ?? '' }
}
